import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Instant } from '@js-joda/core';
import { useFetch, usePromise } from '@rad/hooks';
import { parseInstantN } from '@rad/utility/parsers';
import { getParcelView } from '../../../../common/network/property';
import { backToTour } from '../_tour-home';
import TourHomeLoading from './tour-home-loading';
import TourHomeUnavailable from './tour-home-unavailable';
import TourPreviewBanner from './tour-preview-banner';
// Why the tour keeps visitors from opening its homes yet, for a preview to say so; null once they can.
// A home's own story is a separate matter, which the banner says alongside.
const tourClosed = (tour, now) => {
    const starts = parseInstantN(tour.starts);
    return tour.status !== 'active' ? `this tour is ${tour.statusDisplay.toLowerCase()}`
        : starts === null || now.isBefore(starts) ? 'the tour has not begun'
            : null;
};
// The parcel an open home sits on, which every screen about the home is drawn from.
const TourHomeViewLoader = (props) => {
    const [viewPromise] = useFetch(getParcelView(props.stop.propertyId));
    const view = usePromise(viewPromise);
    if (view === undefined)
        return _jsx(TourHomeLoading, {});
    if (view === null)
        return _jsx(TourHomeUnavailable, Object.assign({ message: "This home's details are not available." }, backToTour(props.tour.id, props.previewing)));
    const tourReason = tourClosed(props.tour, Instant.now());
    const unpublished = props.stop.status !== 'published';
    return _jsxs(_Fragment, { children: [props.previewing && (tourReason !== null || unpublished) && _jsx(TourPreviewBanner, { tourReason: tourReason, unpublished: unpublished }), props.children({ tour: props.tour, stop: props.stop, index: props.index, view, previewing: props.previewing })] });
};
export default TourHomeViewLoader;
